import type {
  GetSitesData,
  GetSitesResponse,

  GetSettingsData,
  GetSettingsResponse,

  GetControlTowerExternalAccessTokensData,
  GetControlTowerExternalAccessTokensResponse,

  PostControlTowerExternalAccessTokensData,
  PostControlTowerExternalAccessTokensResponse,

  DeleteControlTowerExternalAccessTokensByIdData,
  DeleteControlTowerExternalAccessTokensByIdResponse,

  GetControlTowerFeesBySiteIdData,
  GetControlTowerFeesBySiteIdResponse,

  PutControlTowerFeesBySiteIdData,
  PutControlTowerFeesBySiteIdResponse,

  GetControlTowerPaymentMethodsData,
  GetControlTowerPaymentMethodsResponse,

  GetControlTowerPaymentMethodsByIdData,
  GetControlTowerPaymentMethodsByIdResponse,

  PostControlTowerPaymentMethodsData,
  PostControlTowerPaymentMethodsResponse,

  PutControlTowerPaymentMethodsByIdData,
  PutControlTowerPaymentMethodsByIdResponse,

  GetControlTowerCustomersAffiliateProgramNameData,
  GetControlTowerCustomersAffiliateProgramNameResponse,

  PutControlTowerCustomersAffiliateProgramNameData,
  PutControlTowerCustomersAffiliateProgramNameResponse,

  GetControlTowerCustomersEmailSettingsData,
  GetControlTowerCustomersEmailSettingsResponse,

  PutControlTowerCustomersEmailSettingsData,
  PutControlTowerCustomersEmailSettingsResponse,

  GetControlTowerCustomersAffiliateTelegramBotSettingsData,
  GetControlTowerCustomersAffiliateTelegramBotSettingsResponse,

  PutControlTowerCustomersAffiliateTelegramBotSettingsData,
  PutControlTowerCustomersAffiliateTelegramBotSettingsResponse,

  GetControlTowerCustomersPrivacyPolicySettingsData,
  GetControlTowerCustomersPrivacyPolicySettingsResponse,

  PutControlTowerCustomersPrivacyPolicySettingsData,
  PutControlTowerCustomersPrivacyPolicySettingsResponse,

  GetControlTowerCustomersSupportContactsSettingsData,
  GetControlTowerCustomersSupportContactsSettingsResponse,

  PutControlTowerCustomersSupportContactsSettingsData,
  PutControlTowerCustomersSupportContactsSettingsResponse,

  GetControlTowerCustomersAffiliateReferralProgramSettingsData,
  GetControlTowerCustomersAffiliateReferralProgramSettingsResponse,

  PutControlTowerCustomersAffiliateReferralProgramSettingsData,
  PutControlTowerCustomersAffiliateReferralProgramSettingsResponse,

  GetControlTowerCustomersAffiliatePaymentsSettingsData,
  GetControlTowerCustomersAffiliatePaymentsSettingsResponse,

  PutControlTowerCustomersAffiliatePaymentsSettingsData,
  PutControlTowerCustomersAffiliatePaymentsSettingsResponse,

  GetControlTowerCustomersDefaultDomainsNotificationsDefaultSettingsData,
  GetControlTowerCustomersDefaultDomainsNotificationsDefaultSettingsResponse,

  GetControlTowerCustomersAffiliatesLimitsData,
  GetControlTowerCustomersAffiliatesLimitsResponse,

  PutControlTowerCustomersAffiliatesLimitsData,
  PutControlTowerCustomersAffiliatesLimitsResponse,

  PutControlTowerCustomersDefaultDomainsNotificationsSettingsData,
  PutControlTowerCustomersDefaultDomainsNotificationsSettingsResponse,

  GetControlTowerCustomerDomainsData,
  GetControlTowerCustomerDomainsResponse,

  DeleteControlTowerCustomerDomainsByCountryCodeData,
  DeleteControlTowerCustomerDomainsByCountryCodeResponse,

  PutControlTowerCustomerDomainsByCountryCodeData,
  PutControlTowerCustomerDomainsByCountryCodeResponse,

  PutControlTowerCustomerDomainsByCountryCodeSetDefaultData,
  PutControlTowerCustomerDomainsByCountryCodeSetDefaultResponse,

  GetControlTowerFinalPagesBySiteIdData,
  GetControlTowerFinalPagesBySiteIdResponse,

  PutControlTowerFinalPagesBySiteIdData,
  PutControlTowerFinalPagesBySiteIdResponse,

  GetControlTowerCountriesTagsData,
  GetControlTowerCountriesTagsResponse,

  PostControlTowerCountriesTagsData,
  PostControlTowerCountriesTagsResponse,

  PutControlTowerCountriesTagsByIdData,
  PutControlTowerCountriesTagsByIdResponse,

  DeleteControlTowerCountriesTagsByIdData,
  DeleteControlTowerCountriesTagsByIdResponse,

  GetControlTowerCustomerCurrenciesData,
  GetControlTowerCustomerCurrenciesResponse,

  PostControlTowerCustomerCurrenciesData,
  PostControlTowerCustomerCurrenciesResponse,

  DeleteControlTowerCustomerCurrenciesByCurrencyCodeData,
  DeleteControlTowerCustomerCurrenciesByCurrencyCodeResponse,

  PutControlTowerCustomerCurrenciesByCurrencyCodeSetDefaultData,
  PutControlTowerCustomerCurrenciesByCurrencyCodeSetDefaultResponse,

  GetControlTowerMediaBuyingPaymentMethodsData,
  GetControlTowerMediaBuyingPaymentMethodsResponse,

  GetControlTowerMediaBuyingPaymentMethodsByIdData,
  GetControlTowerMediaBuyingPaymentMethodsByIdResponse,

  PostControlTowerMediaBuyingPaymentMethodsData,
  PostControlTowerMediaBuyingPaymentMethodsResponse,

  PutControlTowerMediaBuyingPaymentMethodsByIdData,
  PutControlTowerMediaBuyingPaymentMethodsByIdResponse,

  GetControlTowerCustomersOfferDistributionSettingsData,
  GetControlTowerCustomersOfferDistributionSettingsResponse,

  PutControlTowerCustomersOfferDistributionSettingsData,
  PutControlTowerCustomersOfferDistributionSettingsResponse,
  GetControlTowerCustomersGeoTrafficSettingsResponse,
  PutControlTowerCustomersGeoTrafficSettingsData,
  PutControlTowerCustomersGeoTrafficSettingsResponse,
  GetControlTowerCustomersDomainReachabilitySettingsResponse,
  PutControlTowerCustomersDomainReachabilitySettingsData,
  PutControlTowerCustomersDomainReachabilitySettingsResponse,
  GetControlTowerCustomersIntercomSettingsResponse,
  DeleteControlTowerCustomersIntercomSettingsResponse,
  PutControlTowerCustomersIntercomSettingsData,
  PutControlTowerCustomersIntercomSettingsResponse,
  GetControlTowerCustomersIntegrationStatusesResponse,
  PutControlTowerCustomersKycSettingsData,
  PutControlTowerCustomersKycSettingsResponse,
  GetControlTowerCustomersKycSettingsResponse,
} from '@/types/openapi-ts';
import type { AxiosInstance } from "axios";

export function getSettingsApiModule(affiliatesApi: AxiosInstance) {
  return {
    // ts-expect-error GetSitesData не имеет ['query']
    getSiteSettings(params?: any) {
      return affiliatesApi.get<GetSitesResponse>('/sites', { params });
    },

    getSettings() {
      return affiliatesApi.get<GetSettingsResponse>('/settings');
    },

    getAccessTokens(params: GetControlTowerExternalAccessTokensData['query']) {
      return affiliatesApi.get<GetControlTowerExternalAccessTokensResponse>(
        '/control-tower/external-access-tokens',
        { params }
      );
    },

    postAccessToken(params: PostControlTowerExternalAccessTokensData['body']) {
      return affiliatesApi.post<PostControlTowerExternalAccessTokensResponse>(
        '/control-tower/external-access-tokens',
        params
      );
    },

    deleteAccessToken(id: string) {
      return affiliatesApi.delete<DeleteControlTowerExternalAccessTokensByIdResponse>(
        `/control-tower/external-access-tokens/${id}`
      );
    },
    getFees(siteId: string) {
      return affiliatesApi.get<GetControlTowerFeesBySiteIdResponse>(`/control-tower/fees/${siteId}`);
    },

    updateFees(siteId: string, params: PutControlTowerFeesBySiteIdData['body']) {
      return affiliatesApi.put<PutControlTowerFeesBySiteIdResponse>(`/control-tower/fees/${siteId}`, params);
    },
    getControlPaymentMethods(params: GetControlTowerPaymentMethodsData['query']) {
      return affiliatesApi.get<GetControlTowerPaymentMethodsResponse>('/control-tower/payment-methods', { params });
    },
    getControlPaymentMethodsById(id: string) {
      return affiliatesApi.get<GetControlTowerPaymentMethodsByIdResponse>(`/control-tower/payment-methods/${id}`);
    },
    postControlPaymentMethods(params: PostControlTowerPaymentMethodsData['body'] ) {
      return affiliatesApi.post<PostControlTowerPaymentMethodsResponse>('/control-tower/payment-methods', params);
    },
    putControlPaymentMethods(id: string, params: PutControlTowerPaymentMethodsByIdData['body']) {
      return affiliatesApi.put<PutControlTowerPaymentMethodsByIdResponse>(`/control-tower/payment-methods/${id}`, params);
    },
    getCustomersKycSettings() {
      return affiliatesApi.get<GetControlTowerCustomersKycSettingsResponse>('/control-tower/customers/kyc-settings');
    },
    putCustomersKycSettings(params: PutControlTowerCustomersKycSettingsData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersKycSettingsResponse>('/control-tower/customers/kyc-settings', params);
    },
    getCustomersAffiliateProgramName() {
      return affiliatesApi.get<GetControlTowerCustomersAffiliateProgramNameResponse>('/control-tower/customers/affiliate-program-name');
    },
    putCustomersAffiliateProgramName(params: PutControlTowerCustomersAffiliateProgramNameData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersAffiliateProgramNameResponse>('/control-tower/customers/affiliate-program-name', params);
    },
    getCustomersEmailSettings() {
      return affiliatesApi.get<GetControlTowerCustomersEmailSettingsResponse>('/control-tower/customers/email-settings');
    },
    putCustomersEmailSettings(params: PutControlTowerCustomersEmailSettingsData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersEmailSettingsResponse>('/control-tower/customers/email-settings', params);
    },
    // getCustomersRecaptchaSettings() {
    //   return affiliatesApi.get('/control-tower/customers/recaptcha-settings');
    // },
    // putCustomersRecaptchaSettings(params) {
    //   return affiliatesApi.put('/control-tower/customers/recaptcha-settings', params);
    // },
    getCustomersAffiliateTelegramBotSettings() {
      return affiliatesApi.get<GetControlTowerCustomersAffiliateTelegramBotSettingsResponse>(
        '/control-tower/customers/affiliate-telegram-bot-settings'
      );
    },
    putCustomersAffiliateTelegramBotSettings(params: PutControlTowerCustomersAffiliateTelegramBotSettingsData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersAffiliateTelegramBotSettingsResponse>(
        '/control-tower/customers/affiliate-telegram-bot-settings',
        params
      );
    },
    getCustomersPrivacyPolicySettings() {
      return affiliatesApi.get<GetControlTowerCustomersPrivacyPolicySettingsResponse>(
        '/control-tower/customers/privacy-policy-settings'
      );
    },
    putCustomersPrivacyPolicySettings(params: PutControlTowerCustomersPrivacyPolicySettingsData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersPrivacyPolicySettingsResponse>(
        '/control-tower/customers/privacy-policy-settings',
        params
      );
    },
    getCustomersSupportContactsSettings() {
      return affiliatesApi.get<GetControlTowerCustomersSupportContactsSettingsResponse>(
        '/control-tower/customers/support-contacts-settings'
      );
    },
    putCustomersSupportContactsSettings(params: PutControlTowerCustomersSupportContactsSettingsData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersSupportContactsSettingsResponse>(
        '/control-tower/customers/support-contacts-settings',
        params
      );
    },
    getCustomersAffiliateReferralProgramSettings() {
      return affiliatesApi.get<GetControlTowerCustomersAffiliateReferralProgramSettingsResponse>(
        '/control-tower/customers/affiliate-referral-program-settings'
      );
    },
    putCustomersAffiliateReferralProgramSettings(
      params: PutControlTowerCustomersAffiliateReferralProgramSettingsData['body']
    ) {
      return affiliatesApi.put<PutControlTowerCustomersAffiliateReferralProgramSettingsResponse>(
        '/control-tower/customers/affiliate-referral-program-settings',
        params
      );
    },
    getCustomersAffiliatePaymentsSettings() {
      return affiliatesApi.get<GetControlTowerCustomersAffiliatePaymentsSettingsResponse>(
        '/control-tower/customers/affiliate-payments-settings'
      );
    },
    putCustomersAffiliatePaymentsSettings(params: PutControlTowerCustomersAffiliatePaymentsSettingsData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersAffiliatePaymentsSettingsResponse>(
        '/control-tower/customers/affiliate-payments-settings',
        params
      );
    },
    getCustomersDefaultDomainsNotificationsSettings() {
      return affiliatesApi.get<GetControlTowerCustomersDefaultDomainsNotificationsDefaultSettingsResponse>(
        '/control-tower/customers/default-domains-notifications-default-settings'
      );
    },
    getCustomersAffiliatesLimits() {
      return affiliatesApi.get<GetControlTowerCustomersAffiliatesLimitsResponse>(
        '/control-tower/customers/affiliates-limits'
      );
    },
    putCustomersAffiliatesLimits(params: PutControlTowerCustomersAffiliatesLimitsData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersAffiliatesLimitsResponse>(
        '/control-tower/customers/affiliates-limits',
        params
      );
    },
    putCustomersDefaultDomainsNotificationsSettings(
      params: PutControlTowerCustomersDefaultDomainsNotificationsSettingsData['body']
    ) {
      return affiliatesApi.put<PutControlTowerCustomersDefaultDomainsNotificationsSettingsResponse>(
        '/control-tower/customers/default-domains-notifications-settings',
        params
      );
    },
    getCustomerDomains() {
      return affiliatesApi.get<GetControlTowerCustomerDomainsResponse>('/control-tower/customer-domains');
    },
    deleteCustomerDomains(
      { country_code }: {country_code: DeleteControlTowerCustomerDomainsByCountryCodeData['path']['countryCode']}
    ) {
      return affiliatesApi.delete<DeleteControlTowerCustomerDomainsByCountryCodeResponse>(
        `/control-tower/customer-domains/${country_code}`
      );
    },
    putCustomerDomains(
      { country_code, ...restParams }: {
        country_code: PutControlTowerCustomerDomainsByCountryCodeData['path']['countryCode'],
      } & PutControlTowerCustomerDomainsByCountryCodeData['body']
    ) {
      return affiliatesApi.put<PutControlTowerCustomerDomainsByCountryCodeResponse>(
        `/control-tower/customer-domains/${country_code}`,
        restParams
      );
    },
    putCustomerDomainsSetDefault(
      { country_code }: { country_code: PutControlTowerCustomerDomainsByCountryCodeSetDefaultData['path']['countryCode'] }
    ) {
      return affiliatesApi.put<PutControlTowerCustomerDomainsByCountryCodeSetDefaultResponse>(
        `/control-tower/customer-domains/${country_code}/set-default`
      );
    },
    getFinalPages({ siteId }: { siteId: GetControlTowerFinalPagesBySiteIdData['path']['siteId'] }) {
      return affiliatesApi.get<GetControlTowerFinalPagesBySiteIdResponse>(`/control-tower/final-pages/${siteId}`);
    },
    putFinalPages(
      { siteId }: { siteId: PutControlTowerFinalPagesBySiteIdData['path']['siteId'] },
      params: PutControlTowerFinalPagesBySiteIdData['body']
    ) {
      return affiliatesApi.put<PutControlTowerFinalPagesBySiteIdResponse>(
        `/control-tower/final-pages/${siteId}`,
        params
      );
    },

    getCountriesTags(params: GetControlTowerCountriesTagsData['query']) {
      return affiliatesApi.get<GetControlTowerCountriesTagsResponse>('/control-tower/countries-tags', { params });
    },
    postCountriesTags(params: PostControlTowerCountriesTagsData['body']) {
      return affiliatesApi.post<PostControlTowerCountriesTagsResponse>('/control-tower/countries-tags', params);
    },
    putCountriesTags(id: string, params: PutControlTowerCountriesTagsByIdData['body']) {
      return affiliatesApi.put<PutControlTowerCountriesTagsByIdResponse>(`/control-tower/countries-tags/${id}`, params);
    },
    deleteCountriesTags(id: string) {
      return affiliatesApi.delete<DeleteControlTowerCountriesTagsByIdResponse>(`/control-tower/countries-tags/${id}`);
    },
    // ts-expect-error GetControlTowerCustomerCurrenciesData не имеет ['query']
    getCustomerCurrencies(params?: any) {
      return affiliatesApi.get<GetControlTowerCustomerCurrenciesResponse>(
        '/control-tower/customer-currencies',
        { params }
      );
    },
    postCustomerCurrencies(params: PostControlTowerCustomerCurrenciesData['body']) {
      return affiliatesApi.post<PostControlTowerCustomerCurrenciesResponse>(
        '/control-tower/customer-currencies',
        params
      );
    },
    deleteCurrency(code: string) {
      return affiliatesApi.delete<DeleteControlTowerCustomerCurrenciesByCurrencyCodeResponse>(
        `/control-tower/customer-currencies/${code}`
      );
    },
    putCurrencySetDefault(
      { code }: {code: PutControlTowerCustomerCurrenciesByCurrencyCodeSetDefaultData['path']['currencyCode']}
    ) {
      return affiliatesApi.put<PutControlTowerCustomerCurrenciesByCurrencyCodeSetDefaultResponse>(
        `/control-tower/customer-currencies/${code}/set-default`
      );
    },
    getControlMediaBuyingPaymentMethods(params: GetControlTowerMediaBuyingPaymentMethodsData['query']) {
      return affiliatesApi.get<GetControlTowerMediaBuyingPaymentMethodsResponse>(
        '/control-tower/media-buying-payment-methods',
        { params }
      );
    },
    getControlMediaBuyingPaymentMethodById(id: string) {
      return affiliatesApi.get<GetControlTowerMediaBuyingPaymentMethodsByIdResponse>(
        `/control-tower/media-buying-payment-methods/${id}`
      );
    },
    postControlMediaBuyingPaymentMethods(params: PostControlTowerMediaBuyingPaymentMethodsData['body']) {
      return affiliatesApi.post<PostControlTowerMediaBuyingPaymentMethodsResponse>(
        '/control-tower/media-buying-payment-methods',
        params
      );
    },
    putControlMediaBuyingPaymentMethods(id: string, params: PutControlTowerMediaBuyingPaymentMethodsByIdData['body']) {
      return affiliatesApi.put<PutControlTowerMediaBuyingPaymentMethodsByIdResponse>(
        `/control-tower/media-buying-payment-methods/${id}`,
        params
      );
    },
    getCustomersOfferDistributionSettings() {
      return affiliatesApi.get<GetControlTowerCustomersOfferDistributionSettingsResponse>(
        '/control-tower/customers/offer-distribution-settings'
      );
    },
    putCustomersOfferDistributionSettings(params: PutControlTowerCustomersOfferDistributionSettingsData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersOfferDistributionSettingsResponse>(
        '/control-tower/customers/offer-distribution-settings',
        params
      );
    },
    getCustomersGeoTrafficSettings() {
      return affiliatesApi.get<GetControlTowerCustomersGeoTrafficSettingsResponse>(
        '/control-tower/customers/geo-traffic-settings'
      );
    },
    putCustomersGeoTrafficSettings(params: PutControlTowerCustomersGeoTrafficSettingsData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersGeoTrafficSettingsResponse>(
        '/control-tower/customers/geo-traffic-settings',
        params
      );
    },
    getCustomersDomainReachabilitySettings() {
      return affiliatesApi.get<GetControlTowerCustomersDomainReachabilitySettingsResponse>(
        '/control-tower/customers/domain-reachability-settings'
      );
    },
    putCustomersDomainReachabilitySettings(params: PutControlTowerCustomersDomainReachabilitySettingsData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersDomainReachabilitySettingsResponse>(
        '/control-tower/customers/domain-reachability-settings',
        params
      );
    },
    getCustomersIntercomSettings() {
      return affiliatesApi.get<GetControlTowerCustomersIntercomSettingsResponse>(
        '/control-tower/customers/intercom-settings'
      );
    },
    putCustomersIntercomSettings(params: PutControlTowerCustomersIntercomSettingsData['body']) {
      return affiliatesApi.put<PutControlTowerCustomersIntercomSettingsResponse>(
        '/control-tower/customers/intercom-settings',
        params
      );
    },
    deleteCustomersIntercomSettings() {
      return affiliatesApi.delete<DeleteControlTowerCustomersIntercomSettingsResponse>(
        '/control-tower/customers/intercom-settings'
      );
    },
    getCustomersIntegrationStatuses() {
      return affiliatesApi.get<GetControlTowerCustomersIntegrationStatusesResponse>(
        '/control-tower/customers/integration-statuses'
      );
    },
  }
}
